import {NumberFormatOptions} from "@syncfusion/ej2-base/src/internationalization";

export class InternationalizationNumberFormatOptions {
  options: NumberFormatOptions = {};

  // Direct property mappings

  minimumFractionDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.minimumFractionDigits = value;
    return this;
  }

  maximumFractionDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.maximumFractionDigits = value;
    return this;
  }

  minimumSignificantDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.minimumSignificantDigits = value;
    return this;
  }

  maximumSignificantDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.maximumSignificantDigits = value;
    return this;
  }

  useGrouping(value: boolean): InternationalizationNumberFormatOptions {
    this.options.useGrouping = value;
    return this;
  }

  skeleton(value: string): InternationalizationNumberFormatOptions {
    this.options.skeleton = value;
    return this;
  }

  currency(value: string): InternationalizationNumberFormatOptions {
    this.options.currency = value;
    return this;
  }

  minimumIntegerDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.minimumIntegerDigits = value;
    return this;
  }

  format(value: string): InternationalizationNumberFormatOptions {
    this.options.format = value;
    return this;
  }

  altSymbol(value: string): InternationalizationNumberFormatOptions {
    this.options.altSymbol = value;
    return this;
  }

  // Custom property mappings

  withFractionDigits(value: number): InternationalizationNumberFormatOptions {
    this.options.minimumFractionDigits = value;
    this.options.maximumFractionDigits = value;
    return this;
  }

  asCurrency(): InternationalizationNumberFormatOptions {
    this.options.format = 'C';
    return this;
  }

  asAccounting(): InternationalizationNumberFormatOptions {
    this.options.format = 'A';
    return this;
  }

  asPercentage(): InternationalizationNumberFormatOptions {
    this.options.format = 'P';
    return this;
  }

  asNumber(): InternationalizationNumberFormatOptions {
    this.options.format = 'N';
    return this;
  }

  build(): NumberFormatOptions {
    return this.options;
  }
}

